import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { Section } from "@/components/PolicyLayout";
import { COMPANY } from "@/constants/company";

export default function Privacy() {
    return (
        <PolicyLayout
            eyebrow="Legal" title="Privacy policy" testId="privacy-page"
            intro="You are handing us photos of your family. Here is exactly what we hold, why we hold it, and how to get rid of it.">

            <Section heading="What we collect">
                <p><strong>Your account.</strong> Name, and an email address or phone number. Passwords are stored only as a bcrypt hash — nobody here can read yours.</p>
                <p><strong>Your story.</strong> Photos of the child and the cast, their names, ages and personality notes, and the choices you make in the wizard.</p>
                <p><strong>Your orders.</strong> What you bought, when, the amount, and a payment reference. For hardcovers, the delivery address and contact phone.</p>
                <p><strong>Nothing about your card.</strong> Card and netbanking details are entered on Razorpay's own checkout and never reach our servers. UPI payments carry only a reference number.</p>
            </Section>

            <Section heading="Why we hold it">
                <p>
                    To draw and deliver your book, to keep your library available to you, to take payment
                    and send order updates, and to answer you when you write in. That's the whole list —
                    we do not build advertising profiles and we do not sell data to anyone.
                </p>
            </Section>

            <Section heading="Children's photos">
                <p>
                    Photos of children are used for one thing: producing the book you ordered. They are
                    visible to the illustrator assigned to your order and to nobody else. We do not use
                    them in samples, marketing or on our public pages unless you specifically ask us to.
                </p>
                <p>
                    Delete a character or a book from your library and its photos go with it.
                </p>
            </Section>

            <Section heading="Who else sees it">
                <p><strong>Razorpay</strong> — payment processing, when you pay by card or netbanking.</p>
                <p><strong>Our email provider</strong> — to deliver order and account emails to you.</p>
                <p><strong>Our print partner</strong> — for hardcover orders only, and only the artwork plus the delivery address needed to post it.</p>
                <p>Beyond that, we share personal data only where the law requires it.</p>
            </Section>

            <Section heading="How long we keep it">
                <p>
                    Your library stays available while your account is open, so you can re-download a
                    book years later. Order records are kept as long as tax and accounting rules require.
                </p>
                <p>
                    Ask us to close your account and we delete your characters, books and photos.
                </p>
            </Section>

            <Section heading="Your choices">
                <p>
                    You can ask for a copy of what we hold about you, ask us to correct it, or ask us to
                    delete it. Write to{" "}
                    <a href={`mailto:${COMPANY.email}`} className="underline hover:text-plum">{COMPANY.email}</a>{" "}
                    from the address on your account and we'll action it within 30 days.
                </p>
                <p>
                    Shared reading links are public to anyone holding the link — revoke one from the book
                    if you no longer want it circulating.
                </p>
            </Section>

            <Section heading="Security, honestly stated">
                <p>
                    Traffic runs over HTTPS, passwords are hashed, and sessions expire. Your photos and
                    artwork live in our database with access limited to the people who run the service.
                </p>
                <p>
                    No system is perfect. If we ever have a breach that affects your data, we will tell
                    you rather than wait for you to find out.
                </p>
            </Section>

            <Section heading="Contact">
                <p>
                    Privacy questions go to{" "}
                    <a href={`mailto:${COMPANY.email}`} className="underline hover:text-plum">{COMPANY.email}</a>.
                    See also our <Link to="/terms" className="underline hover:text-plum">terms</Link> and{" "}
                    <Link to="/refund-policy" className="underline hover:text-plum">refunds policy</Link>.
                </p>
            </Section>
        </PolicyLayout>
    );
}
